import React from "react";

export default function ErrorPage() {
  return (
    <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
      <h1>404 Error</h1>
      <p>Page not found</p>
    </div>
  );
}
